import type React from "react";

function SkeletonLine({ className = "", style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <div className={`animate-pulse rounded bg-gray-800 ${className}`} style={style} />
  );
}

export function FileListSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="flex-1 overflow-hidden">
      {/* Header row */}
      <div className="flex items-center border-b border-gray-800 px-4 py-2">
        <SkeletonLine className="h-3 w-24" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-3 border-b border-gray-800/50 px-4 py-3"
          style={{ opacity: 1 - i * 0.08 }}
        >
          {/* Icon */}
          <SkeletonLine className="h-5 w-5 flex-shrink-0 rounded" />
          {/* Name */}
          <SkeletonLine className="h-3.5 flex-1" style={{ maxWidth: `${40 + (i % 4) * 15}%` }} />
          {/* Size — desktop */}
          <SkeletonLine className="hidden h-3 w-14 sm:block" />
          {/* Date — desktop */}
          <SkeletonLine className="hidden h-3 w-20 sm:block" />
          {/* Action dots */}
          <SkeletonLine className="h-6 w-6 rounded-full flex-shrink-0" />
        </div>
      ))}
    </div>
  );
}

export function TrashListSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div className="flex-1 overflow-hidden">
      <div className="flex items-center border-b border-gray-800 px-4 py-2">
        <SkeletonLine className="h-3 w-20" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-3 border-b border-gray-800/50 px-4 py-3"
          style={{ opacity: 1 - i * 0.1 }}
        >
          <SkeletonLine className="h-5 w-5 flex-shrink-0 rounded" />
          <SkeletonLine className="h-3.5 flex-1" style={{ maxWidth: `${35 + (i % 3) * 20}%` }} />
          <SkeletonLine className="hidden h-3 w-24 sm:block" />
          <div className="flex gap-2">
            <SkeletonLine className="hidden h-7 w-16 rounded-lg sm:block" />
            <SkeletonLine className="hidden h-7 w-16 rounded-lg sm:block" />
          </div>
        </div>
      ))}
    </div>
  );
}
